import React, { useCallback, useMemo } from 'react';

import logo from 'src/images/journey-logo-new.svg';
import OnboardingAssistant from '../onboarding-assistant';
import { LeftStrongIcon } from 'src/monet/icons';
import { useHistory, useLocation } from 'react-router-dom';
import { IconButton } from 'src/common/icon-button';
import ElegantBackground from './elegant-background';
import FloatingElement from './floating-element';

// TODO - manage placement and width from store

interface OnboardingLayoutProps {
  children: React.ReactNode;
  fixedTopMargin?: boolean;
  fullSizeContent?: boolean;
  centerContent?: boolean;
}

const OnboardingLayout = ({ 
  children, 
  fixedTopMargin = false, 
  fullSizeContent = false,
  centerContent = false 
}: OnboardingLayoutProps) => {
  const onLogoClick = useCallback(() => {
    window.location.href = 'https://journey.io';
  }, []);

  const { show: showBackButton, onBack } = useShowOnboardingBackButton();

  return (
    <div className="min-h-screen flex flex-col relative">
      <ElegantBackground />
      
      {/* Decorative floating elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <FloatingElement
          className="absolute top-[10%] left-[5%]"
          translateY="30px"
          translateX="10px"
          rotate="5deg"
          duration={8}
        >
          <div className="w-32 h-32 rounded-full bg-[#1A1F71] opacity-[0.03]" />
        </FloatingElement>
        
        <FloatingElement
          className="absolute bottom-[15%] right-[10%]"
          translateY="-20px"
          translateX="-15px"
          rotate="-3deg"
          duration={10}
          delay={2}
        >
          <div className="w-48 h-48 rounded-full bg-[#1A1F71] opacity-[0.02]" />
        </FloatingElement>
        
        <FloatingElement
          className="absolute top-[30%] right-[15%]"
          translateY="15px"
          translateX="-10px"
          scale="1.03"
          duration={7}
          delay={1}
        >
          <div className="w-24 h-24 rounded-full bg-[#1A1F71] opacity-[0.015]" />
        </FloatingElement>
      </div>
      
      {/* Header with logo */}
      <header className="px-6 py-8 relative z-10">
        <img
          src={logo}
          alt="journey-logo"
          className="cursor-pointer h-8"
          onClick={onLogoClick}
        />
      </header>

      {/* Main content area */}
      <main className={`flex-1 overflow-auto relative z-10 ${centerContent ? 'flex items-center justify-center' : ''}`}>
        {showBackButton && (
          <div className="px-6 mb-4">
            <IconButton onClick={onBack}>
              <LeftStrongIcon />
            </IconButton>
          </div>
        )}

        <div className={`${centerContent ? 'w-full max-w-md mx-auto px-6' : 'w-full max-w-screen-xl mx-auto px-6 py-8'}`}>
          {/* <OnboardingAssistant /> */}
          {children}
        </div>
      </main>
    </div>
  );
};

const useShowOnboardingBackButton = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const show = useMemo(() => ['/onboarding/organization', '/onboarding/brand'].includes(pathname), [pathname]);
  const onBack = useCallback(() => {
    history.goBack();
  }, []);

  return { show, onBack };
};

export default OnboardingLayout;
